/*import {XRStoreOptions} from "@react-three/xr";
import {WebXRManager} from "three";*/

//export let xrSessionsActive = new Set<XRSession>();
/*export let xrSessionStarted = false;
if (navigator.xr) {
	console.log("XR api detected:", navigator.xr);
	navigator.xr.onsessiongranted = (e: XRSystemSessionGrantedEvent)=>{
		console.log("XR session granted:", e.session);
		//xrSessionsActive.add(e.session);
		xrSessionStarted = true;
	}
	navigator.xr.requestSession

	// these appear to not be real events (at least on the quest-3 browser)
	/*navigator.xr.addEventListener("sessionstart", (e: XRSessionEvent)=>{
		console.log("XR session started:", e.session);
		xrSessionsActive.add(e.session);
	});
	navigator.xr.addEventListener("sessionend", (e: XRSessionEvent)=>{
		console.log("XR session ended:", e.session);
		xrSessionsActive.delete(e.session);
	});*#/
}*/

export let xrSessionsActive = new Set<XRSession>();

export const requestSession_orig = navigator.xr?.requestSession;
if (navigator.xr) {
	navigator.xr.requestSession = async function(...args) {
		//const [sessionMode, sessionInit] = args as [XRSessionMode, XRSessionInit | undefined];
		const session = await requestSession_orig!.apply(this, arguments as any as [XRSessionMode, XRSessionInit | undefined]);

		console.log("XR session started:", session);
		xrSessionsActive.add(session);
		session.addEventListener("end", (e: XRSessionEvent)=>{
			console.log("XR session ended:", e.session);
			xrSessionsActive.delete(e.session);
		});

		return session;
	}
}

export const offerSession_orig = navigator.xr?.offerSession;
if (navigator.xr) {
	navigator.xr.offerSession = async function(...args) {
		//const [manager, options, domOverlayRoot] = args as any as [WebXRManager, XRStoreOptions<any> | undefined, Element | undefined];
		//const session = await offerSession_orig!(manager, options, domOverlayRoot);
		//const session = await offerSession_orig!(...args);
		const session = await offerSession_orig!.apply(this, arguments as any as [XRSessionMode, XRSessionInit | undefined]);

		console.log("XR session started:", session);
		xrSessionsActive.add(session);
		session.addEventListener("end", (e: XRSessionEvent)=>{
			console.log("XR session ended:", e.session);
			xrSessionsActive.delete(e.session);
		});

		return session;
	}
}

export const requestAnimationFrame_orig = window.requestAnimationFrame;
if (navigator.xr) {
	window.requestAnimationFrame = (callback: FrameRequestCallback)=>{
		// When an xr session is active, the regular requestAnimationFrame function does not work! So just call setTimeout instead.
		// See: https://communityforums.atmeta.com/t5/General-VR-MR-Development/window-requestAnimationFrame-not-working-in-newest-33-3-Meta/td-p/1201447
		if (xrSessionsActive.size > 0) {
		//if (xrSessionStarted) {
			return setTimeout(callback, 0);
		}
		return requestAnimationFrame_orig(callback);
	};
}